import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../services/serviceCaller";
import { toast } from "react-toastify";
import { FileUploader } from "../../../components/ImageUploader";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import * as Yup from "yup";

const AwardMaster = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchAward();
    dispatch(updateNavbarHeading("Award Master"));
  }, []);

  const initialFormData = {
    Title: "",
    Score: null,
    Image: null,
    Remark: "",
    FilePath: "",
    IsInActive: 0,
  };

  const [award, setAward] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [profilePic, setProfilePic] = useState();
  const [formData, setFormData] = useState(initialFormData);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [modalName, setModalName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [errors, setErrors] = useState({});
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const schema = Yup.object().shape({
    Title: Yup.string().required("Title is required"),
    Score: Yup.number().required("Score is required"),
    Image: Yup.mixed().test("fileRequired", "Image is required", (value) => {
      // For edit mode, if we have FilePath, we don't need to validate Image
      if (modalName === "Edit" && formData.FilePath) return true;
      return value !== null;
    }),
  });

  const validateField = async (fieldName, value) => {
    try {
      await schema.validateAt(fieldName, { [fieldName]: value });
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
    }
  };

  const fetchAward = async () => {
    SetApiStatus(undefined);
    try {
      const response = await GetServiceCaller(`${API_URL}award-master`);
      if (response?.status === 200) {
        SetApiStatus(response?.status);
        const data = response?.data?.data;
        setAward(data);
        const allNames = data.map((item) => item.title);
        setSuggestions(allNames);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const columns = {
    title: { text: "Title", align: "start", visible: true },
    FileName: { text: "Badge", align: "left", type: "Image", visible: true },
    score: { text: "Score", align: "center", width: "30px", visible: true },
    remarks: { text: "Remarks", align: "start", visible: true, width: "100px" },
    IsInActive: {
      text: "Active",
      align: "center",
      width: "40px",
      visible: true,
    },
  };

  const handleInputChange = async (e) => {
    const { name, value, checked, type } = e.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
    if (name === "Title") {
      const matchedSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }

    const updatedData = {
      ...formData,
      [name]: newValue,
    };

    setFormData(updatedData);
    await validateField(name, newValue);
  };

  const handleFile = (file) => {
    if (!file) {
      setErrors((prev) => ({ ...prev, Image: "Image is required" }));
      return;
    }

    const fileType = file.type;
    const fileSize = file.size;
    const validTypes = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml"];
    if (!validTypes.includes(fileType)) {
      setErrors((prev) => ({
        ...prev,
        Image: "Only PNG, JPEG, JPG, or SVG formats are allowed",
      }));
      return;
    }
    if (fileSize > 300 * 1024) {
      setErrors((prev) => ({
        ...prev,
        Image: "File size should be less than 300 KB",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, Image: "" }));

    const previewUrl = URL.createObjectURL(file);
    setProfilePic(previewUrl);
    setFormData((prev) => ({
      ...prev,
      Image: file,
      FilePath: "",
    }));

    setFileName(file.name);
  };
  const handleEdit = async (id) => {
    setModalName("Edit");
    setShowModal(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}award-master/${id.id}`
      );
      if (response.status === 200) {
        const quesData = response?.data?.data;
        if (quesData) {
          const { title, score, FileName, remarks, IsInActive, oldFileName } =
            quesData;
          setProfilePic(oldFileName);
          setFormData({
            id: id.id,
            Title: title || "",
            Score: score || null,
            Remark: remarks || "",
            Image: FileName,
            FilePath: oldFileName || "",
            IsInActive: IsInActive === 1 ? 1 : 0,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching award details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Validate entire form
      await schema.validate(formData, { abortEarly: false });

      const formDataToSend = new FormData();
      formDataToSend.append("Title", formData.Title);
      formDataToSend.append("Score", formData.Score);
      formDataToSend.append("Remark", formData.Remark);
      formDataToSend.append("IsInActive", formData.IsInActive);

      if (formData.Image instanceof File) {
        formDataToSend.append("Image", formData.Image);
      } else if (modalName === "Add") {
        throw new Error("Image is required");
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const url = formData.id
        ? `${API_URL}award-master/${formData.id}`
        : `${API_URL}award-master`;
      const method = formData.id ? "put" : "post";

      const response = await PostFormServiceCaller(url, formDataToSend, method, config);

      // Check for successful response
      if (response?.status === 200 || response?.statusCode === 200 || response?.status === "success") {
        toast.success(formData.id ? "Award updated successfully!" : "Award created successfully!");
        handleEditModalClose();
        return; // Explicit return after success
      }

      // Handle API errors (non-200 responses)
      const apiErrorMessage = response?.data?.message;
      throw new Error(apiErrorMessage); // Throw to be caught by the catch block

    } catch (error) {
      if (error.inner) {
        // Yup validation errors
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
        toast.error("Please fix the validation errors");
      } else {
        // All other errors (including our thrown API errors)
        console.error("Submission error:", error); // Log full error for debugging
      }
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const suggestionsElement = document.querySelector(
        ".suggestions-container"
      );
      const inputElement = document.getElementById("Title");
      if (
        showSuggestions &&
        suggestionsElement &&
        !suggestionsElement.contains(event.target) &&
        inputElement !== event.target
      ) {
        setShowSuggestions(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, showSuggestions]);
  const handleEditModalClose = () => {
    setShowModal(false);
    setFormData(initialFormData);
    setErrors({});
    setProfilePic(null);
    setFileName(null);
    fetchAward();
  };

  const handleAddAward = () => {
    setShowModal(true);
    setModalName("Add");
    setFormData(initialFormData);
    setProfilePic(null);
    setFileName(null);
    setErrors({});
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={award}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              isActionRequired={true}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              showIcon3={false}
              showIcon4={false}
              showIcon5={false}
              isFilterRequired={false}
              isSorting={false}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              hanldeImageClick={handleImageClick}
              handleAddNew={handleAddAward}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
                Icon2: <i className="bi bi-people-fill icons"></i>,
                Icon2Text: " Employee Selection",
                Icon3Text: "Interview Status",
                Icon3: <i className="bi bi-box-arrow-up-right icons"></i>,
                Icon4: <i className="bi bi-envelope icons"></i>,
                Icon4Text: "Send JD",
                Icon5Text: "JD",
                Icon5: <i className="bi bi-eye-fill icons"></i>,
              }}
            />
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >{`${modalName} Award`}</p>
                <span className="me-2">
                  <i className="bi bi-x-lg" onClick={handleEditModalClose}></i>
                </span>
              </div>
              <div className="modal-body">
                <div className="box-body">
                  <Form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-8">
                        <label htmlFor="Title" className="form-label">
                          Title<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.Title ? "is-invalid" : ""
                            }`}
                          id="Title"
                          name="Title"
                          value={formData.Title}
                          onChange={handleInputChange}
                        />
                        {showSuggestions && filteredSuggestions.length > 0 && (
                          <div
                            className="suggestions-container"
                            style={{
                              position: "absolute",
                              width: "60%",
                              maxHeight: "200px",
                              overflowY: "auto",
                              backgroundColor: "#fff",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              zIndex: 1000,
                              marginTop: "2px",
                            }}
                          >
                            <div
                              style={{
                                padding: "8px 12px",
                                fontSize: "0.8rem",
                                color: "#666",
                                borderBottom: "1px solid #eee",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              Existing matching Award:
                            </div>
                            <ul
                              style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              {filteredSuggestions.map((suggestion, index) => (
                                <li
                                  key={index}
                                  style={{
                                    padding: "8px 12px",
                                    fontSize: "0.9rem",
                                    borderBottom: "1px solid #eee",
                                    color: "#333",
                                    cursor: "default", // Disable pointer cursor
                                  }}
                                >
                                  {suggestion}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {errors.Title && (
                          <div className="invalid-feedback">{errors.Title}</div>
                        )}
                      </div>
                      <div className="col-4">
                        <label htmlFor="Score" className="form-label">
                          Score<span className="required">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control ${errors.Score ? "is-invalid" : ""
                            }`}
                          id="Score"
                          name="Score"
                          value={formData.Score}
                          onChange={handleInputChange}
                        />
                        {errors.Score && (
                          <div className="invalid-feedback">{errors.Score}</div>
                        )}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12 d-flex gap-2">
                        <label htmlFor="Title" className="form-label">
                          Image <span className="required">*</span>
                        </label>
                        {profilePic && (
                          <div className="award_img">
                            <img
                              src={profilePic}
                              alt="Badge Preview"
                              width="80"
                              height="80"
                            />
                          </div>
                        )}
                        <div className="file-upload-container mt-3">
                          <FileUploader
                            handleFile={handleFile}
                            allowFileType
                            fileName={fileName}
                            title="attach"
                          />
                          {errors.Image && (
                            <div className="text-danger small mt-1">
                              {errors.Image}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <label htmlFor="Remark" className="form-label">
                          Remark
                        </label>
                        <textarea
                          className="form-control"
                          id="Remark"
                          name="Remark"
                          value={formData.Remark}
                          onChange={handleInputChange}
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12">
                        <label htmlFor="IsInActive" className="form-label">
                          Active
                        </label>
                        <input
                          className="form-check-input m-1"
                          type="checkbox"
                          name="IsInActive"
                          id="flexSwitchCheckChecked"
                          checked={formData.IsInActive === 1}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="cancel-btn me-2"
                        onClick={handleEditModalClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="custom-btn">
                        Submit
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal show={isModalOpen} onHide={closeModal} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Badge Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={selectedImage}
            alt="Enlarged Profile"
            style={{ maxWidth: "100%", maxHeight: "70vh" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AwardMaster;
